import React from "react";
import classnames from "classnames";

export default ({ isOpen, children }) => (
  <main className={classnames({ isOpen })}>
    <div>{children}</div>
  </main>
);
